import { render, staticRenderFns } from "./uploadResume.vue?vue&type=template&id=2d9c8854&scoped=true&"
import script from "./uploadResume.vue?vue&type=script&lang=js&"
export * from "./uploadResume.vue?vue&type=script&lang=js&"
import style0 from "./uploadResume.vue?vue&type=style&index=0&id=2d9c8854&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9c8854",
  null
  
)

export default component.exports